(function (global) {
  function escapeCsvCell(value) {
    if (value === null || value === undefined) return '';
    const stringValue = String(value);
    if (/[",\n]/.test(stringValue)) {
      return '"' + stringValue.replace(/"/g, '""') + '"';
    }
    return stringValue;
  }

  function normalizeRow(row) {
    return row.map((cell) => escapeCsvCell(cell));
  }

  function buildCsvContent(headers, rows) {
    let csvContent = normalizeRow(headers).join(',') + '\n';
    rows.forEach((row) => {
      csvContent += normalizeRow(row).join(',') + '\n';
    });
    return csvContent;
  }

  function downloadCsv(csvContent, filename) {
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  }

  function exportCsv(headers, rows, filename) {
    const csvContent = buildCsvContent(headers, rows);
    downloadCsv(csvContent, filename);
  }

  function rowsFromObjects(items, fields) {
    return (items || []).map((item) => {
      return fields.map((field) => {
        if (typeof field === 'string') return item[field];
        if (field && typeof field.get === 'function') return field.get(item);
        return '';
      });
    });
  }

  function exportCsvFromObjects(fields, items, filename) {
    const headers = fields.map((field) => (typeof field === 'string' ? field : field.header));
    const rows = rowsFromObjects(items, fields);
    exportCsv(headers, rows, filename);
  }

  global.ExportUtils = {
    escapeCsvCell,
    rowsFromObjects,
    buildCsvContent,
    downloadCsv,
    exportCsv,
    exportCsvFromObjects
  };
})(window);
